<template>
    <b-form-group
            class="c-text"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <label
                v-if="readOnly">{{Core.Currency.format(dataValue)}}</label>
        <input
                v-else
                type="text"
                :id="id"
                v-model="dataValue"
                :state="chkState(id)"
                class="form-control"/>
        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
            {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
  export default {
      name: 'InputCurrency',
      props: {
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: String | Number,
              default: '0'
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              if (val !== undefined) {
                  val = val.toString().replace(',','.')
                  this.dataValue = val
              }
          },
          dataValue(val) {
              this.$emit('input', val.toString().replace(',','.'))
              this.$emit('change', val.toString().replace(',','.'))
          }
      },
      mounted() {
          this.dataValue = this.value.toString().replace(',','.')
      },
      data: () => {
          return {
              Core: window.Core,
              dataValue: '0'
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>